import api from "../api";
import backEnd from "../../constants/backEnd";

const postStripeCheckout = async (subscriptionId) => {
    const response = await api.post(`${backEnd.url}webhooks/stripe/checkout/`, {
        subscription_id: subscriptionId,
    });
    
    return response.data;
};

export default postStripeCheckout;
